export default "__VITE_ASSET__DT44rbUQ__"